import React from 'react'
import { FormControl, FormHelperText, Grid, Typography, Popper } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import useMyAutocomplete from './useAutocomplete'
import { TOptions, MyAutocompleteViewProps, MyAutocompleteProps } from './autocompleteType'
import { makeStyles } from '@material-ui/core/styles'
import { omit } from 'lodash'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import Tooltip from '@material-ui/core/Tooltip'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

let MyAutocompleteView: React.FC<MyAutocompleteViewProps> = ({
    onChangeValue,
    onOpenOpt,
    materialInputProps,
    field,
    options,
    required,
    error = false,
    zIndex,
}) => {
    const { input, meta } = field
    let isError = false
    if (required || error) {
        isError = (meta.error && meta.invalid && meta.touched) || error ? true : false
    }
    const classes = useStyles(isError)
    const getLabel = () => {
        const myLabel = required ? (
            <Grid container className={classes.label}>
                <Grid item>
                    {materialInputProps.label || ''}{' '}
                    <label style={{ color: 'red' }}>{materialInputProps.label ? `*` : ''}</label>
                </Grid>
            </Grid>
        ) : (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{materialInputProps.label || ''}</Typography>
                </Grid>
            </Grid>
        )
        return <Typography variant={'subtitle2'}>{myLabel}</Typography>
    }

    const getValue = () => {
        //ทำแบบนี้เพราะเวลาเปลี่ยนภาษา label จะได้เปลี่ยนตาม
        const val: any = input.value ?? null
        if (val && val !== '') {
            const opt = options ?? []
            const filter = opt.filter((itm) => String(itm.value) === String(val.value))
            if (filter?.length !== 0) {
                return { ...val, label: filter[0].label }
            }
        }

        return input.value
    }
    return (
        <FormControl style={{ height: '108px', width: '100%' }}>
            {getLabel()}

            <Autocomplete
                {...input}
                noOptionsText={<span style={{ fontFamily: 'prompt' }}>ไม่มีข้อมูล</span>}
                options={options}
                getOptionLabel={(option) => (option.label ? option.label : '')}
                disabled={materialInputProps?.disabled}
                getOptionDisabled={(option: any) => option.disabled === true}
                getOptionSelected={(option: any, value: any) => {
                    if (!value) return false
                    return option.value === value.value
                }}
                value={getValue() ? getValue() : null}
                PopperComponent={(props) => (
                    <Popper {...props} style={{ ...props.style, zIndex: zIndex ? zIndex : props.style?.zIndex }} />
                )}
                renderOption={(option: any) =>
                    option.description ? (
                        <Tooltip
                            title={option.description}
                            classes={{ tooltip: classes.tooltip }}
                            arrow
                            placement="top"
                        >
                            <div style={{ width: '100%' }}>{option.label}</div>
                        </Tooltip>
                    ) : (
                        <div style={{ width: '100%' }}>{option.label}</div>
                    )
                }
                renderInput={(params) => {
                    return (
                        <>
                            <TextField
                                {...params}
                                {...omit(materialInputProps, ['label'])}
                                required={required ? true : false}
                                error={isError}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={
                                    materialInputProps?.disabled
                                        ? {
                                              classes: {
                                                  root: classes.inputRoot,

                                                  disabled: classes.disabled,
                                              },
                                              endAdornment: (
                                                  <>
                                                      {' '}
                                                      <ArrowDropDownIcon
                                                          style={{ fontSize: '1.2rem', color: '#0000008a' }}
                                                      />
                                                  </>
                                              ),
                                          }
                                        : {
                                              ...params.InputProps,
                                              classes: {
                                                  root: classes.inputRoot,
                                              },
                                          }
                                }
                            />
                            <FormHelperText className={classes.errorText}>{isError && meta.error}</FormHelperText>
                        </>
                    )
                }}
                onChange={(e, value: TOptions) => {
                    input.onChange(value)

                    if (onChangeValue) {
                        onChangeValue(value)
                    }
                }}
                onOpen={onOpenOpt}
            />
        </FormControl>
    )
}

let MyAutocomplete: React.FC<MyAutocompleteProps> = ({ name, required, validates, options, ...others }) => {
    const myAutocomplete = useMyAutocomplete({ name, required, validates })
    return <MyAutocompleteView {...myAutocomplete} {...others} required={required} options={options} />
}

export default MyAutocomplete

const useStyles = makeStyles((theme) => ({
    tooltip: {
        fontSize: '14px',
    },
    label: {
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
    inputRoot: {
        '&$disabled': {
            color: '#000000',
            backgroundColor: '#F0F0F0C6',
        },
        borderRadius: '8px !important',
    },
    disabled: {},
}))
